//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TenantClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export type GetSubtenantsTenantQueryParameters = {
  subtenantIds?: number[] | null | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type RemoveSubtenantTenantQueryParameters = {
  subtenantId: number ;
}

export type PatchSubtenantTenantQueryParameters = {
  subtenantId: number ;
}

export function getTenantUrl(): string {
  let url_ = getBaseUrl() + "/api/tenants";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getTenantDefaultOptions: Omit<UseQueryOptions<Types.TenantDto, unknown, Types.TenantDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TenantDto, unknown, Types.TenantDto>, 'queryFn'>> = {
};
export function getGetTenantDefaultOptions() {
  return getTenantDefaultOptions;
};
export function setGetTenantDefaultOptions(options: typeof getTenantDefaultOptions) {
  getTenantDefaultOptions = options;
}

export function getTenantQueryKey(): QueryKey;
export function getTenantQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'TenantClient',
      'getTenant',
    ]);
}
export function __getTenant(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getTenant(
axiosConfig    );
}

/**
 * Gets a tenant the user is member of
 */
export function useGetTenantQuery<TSelectData = Types.TenantDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.TenantDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetTenantQuery<TSelectData = Types.TenantDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TenantDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TenantDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getTenant(context, axiosConfig) : __getTenant,
    queryKey: getTenantQueryKey(),
    ...getTenantDefaultOptions as unknown as Omit<UseQueryOptions<Types.TenantDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a tenant the user is member of
 */
export function setGetTenantData(queryClient: QueryClient, updater: (data: Types.TenantDto | undefined) => Types.TenantDto, ) {
  queryClient.setQueryData(getTenantQueryKey(),
    updater
  );
}

/**
 * Gets a tenant the user is member of
 */
export function setGetTenantDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TenantDto | undefined) => Types.TenantDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createTenantUrl(): string {
  let url_ = getBaseUrl() + "/api/tenants";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createTenantMutationKey(): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'createTenant',
    ]);
}

/**
 * Creates new Tenant
 */
export function useCreateTenantMutation<TContext>(options?: Omit<UseMutationOptions<Types.TenantDto, unknown, Types.CreateTenantDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.TenantDto, unknown, Types.CreateTenantDto, TContext> {
  const key = createTenantMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createTenantDto: Types.CreateTenantDto) => Client.createTenant(createTenantDto),
    mutationKey: key,
  });
}
  
export function createSubtenantUrl(): string {
  let url_ = getBaseUrl() + "/api/tenants/subtenants";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createSubtenantMutationKey(): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'createSubtenant',
    ]);
}

/**
 * Creates new Subtenant within current Tenant
 */
export function useCreateSubtenantMutation<TContext>(options?: Omit<UseMutationOptions<Types.SubtenantDto, unknown, Types.CreateSubtenantDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SubtenantDto, unknown, Types.CreateSubtenantDto, TContext> {
  const key = createSubtenantMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createSubtenantDto: Types.CreateSubtenantDto) => Client.createSubtenant(createSubtenantDto),
    mutationKey: key,
  });
}
  
export function getSubtenantsUrl(subtenantIds?: number[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/tenants/subtenants?";
if (subtenantIds !== undefined && subtenantIds !== null)
    subtenantIds && subtenantIds.forEach(item => { url_ += "SubtenantIds=" + encodeURIComponent("" + item) + "&"; });
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSubtenantsDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfSubtenantDto, unknown, Types.PageableListDtoOfSubtenantDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfSubtenantDto, unknown, Types.PageableListDtoOfSubtenantDto>, 'queryFn'>> = {
};
export function getGetSubtenantsDefaultOptions() {
  return getSubtenantsDefaultOptions;
};
export function setGetSubtenantsDefaultOptions(options: typeof getSubtenantsDefaultOptions) {
  getSubtenantsDefaultOptions = options;
}

export function getSubtenantsQueryKey(dto: GetSubtenantsTenantQueryParameters): QueryKey;
export function getSubtenantsQueryKey(subtenantIds?: number[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getSubtenantsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { subtenantIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetSubtenantsTenantQueryParameters;

    return trimArrayEnd([
        'TenantClient',
        'getSubtenants',
        subtenantIds as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'TenantClient',
        'getSubtenants',
        ...params
      ]);
  }
}
export function __getSubtenants(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSubtenants(
      context.queryKey[2] as number[] | null | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as Types.SortDirection | undefined,       context.queryKey[7] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetSubtenantsQuery<TSelectData = Types.PageableListDtoOfSubtenantDto, TError = unknown>(dto: GetSubtenantsTenantQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfSubtenantDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns all Subtenants within current Tenant
 * @param subtenantIds (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetSubtenantsQuery<TSelectData = Types.PageableListDtoOfSubtenantDto, TError = unknown>(subtenantIds?: number[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfSubtenantDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSubtenantsQuery<TSelectData = Types.PageableListDtoOfSubtenantDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfSubtenantDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let subtenantIds: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ subtenantIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetSubtenantsTenantQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [subtenantIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfSubtenantDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSubtenants(context, axiosConfig) : __getSubtenants,
    queryKey: getSubtenantsQueryKey(subtenantIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getSubtenantsDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfSubtenantDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns all Subtenants within current Tenant
 * @param subtenantIds (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetSubtenantsData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfSubtenantDto | undefined) => Types.PageableListDtoOfSubtenantDto, subtenantIds?: number[] | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getSubtenantsQueryKey(subtenantIds, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Returns all Subtenants within current Tenant
 * @param subtenantIds (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetSubtenantsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfSubtenantDto | undefined) => Types.PageableListDtoOfSubtenantDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function removeSubtenantUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/tenants/subtenants/{subtenantId}";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeSubtenantMutationKey(subtenantId: number): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'removeSubtenant',
      subtenantId as any,
    ]);
}

/**
 * Removes a subtenant.
 * @param subtenantId The subtenant ID.
 */
export function useRemoveSubtenantMutation<TContext>(subtenantId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeSubtenantMutationKey(subtenantId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeSubtenant(subtenantId),
    mutationKey: key,
  });
}
  
type RemoveSubtenant__MutationParameters = RemoveSubtenantTenantQueryParameters

/**
 * Removes a subtenant.
 * @param subtenantId The subtenant ID.
 */
export function useRemoveSubtenantMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveSubtenant__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveSubtenantTenantQueryParameters}): UseMutationResult<void, unknown, RemoveSubtenant__MutationParameters, TContext> {
  const key = removeSubtenantMutationKey(options?.parameters?.subtenantId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveSubtenant__MutationParameters) => Client.removeSubtenant(data.subtenantId ?? options?.parameters?.subtenantId!),
  mutationKey: key,
});
}
  
export function patchSubtenantUrl(subtenantId: number): string {
  let url_ = getBaseUrl() + "/api/tenants/subtenants/{subtenantId}";
if (subtenantId === undefined || subtenantId === null)
  throw new Error("The parameter 'subtenantId' must be defined.");
url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchSubtenantMutationKey(subtenantId: number): MutationKey {
  return trimArrayEnd([
      'TenantClient',
      'patchSubtenant',
      subtenantId as any,
    ]);
}

export function usePatchSubtenantMutation<TContext>(subtenantId: number, options?: Omit<UseMutationOptions<Types.SubtenantDto, unknown, Types.PatchSubtenantDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.SubtenantDto, unknown, Types.PatchSubtenantDto, TContext> {
  const key = patchSubtenantMutationKey(subtenantId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (patchSubtenantDto: Types.PatchSubtenantDto) => Client.patchSubtenant(subtenantId, patchSubtenantDto),
    mutationKey: key,
  });
}
  
type PatchSubtenant__MutationParameters = PatchSubtenantTenantQueryParameters & {
  patchSubtenantDto: Types.PatchSubtenantDto;
}

export function usePatchSubtenantMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.SubtenantDto, unknown, PatchSubtenant__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchSubtenantTenantQueryParameters}): UseMutationResult<Types.SubtenantDto, unknown, PatchSubtenant__MutationParameters, TContext> {
  const key = patchSubtenantMutationKey(options?.parameters?.subtenantId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PatchSubtenant__MutationParameters) => Client.patchSubtenant(data.subtenantId ?? options?.parameters?.subtenantId!, data.patchSubtenantDto),
  mutationKey: key,
});
}